
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LottiePlayerComponent } from './lottie-player.component';

@NgModule({
    declarations: [LottiePlayerComponent],
    imports:
        [
            CommonModule,
        ],
    exports: [LottiePlayerComponent] // Exporta o componente para ser usado em outros módulos
})
export class LottiePlayerModule { }